export interface AddressFormData {
  id?: string;
  street: string;
  number: string;
  city: string;
  state: string;
  zipCode: string;
  country: string;
}

export interface ContactFormData {
  id?: string;
  name: string;
  email: string;
  phoneNumber: string;
}

export interface CompanyFormData {
  id: string;
  name: string;
  cnpj: string;
  observation?: string;
  states?: string;
  segment?: string;
  tradeName?: string;
  foundingDate?: string;
  registrationStatus?: string;
  mainActivity?: string;
  // Unidade (1–4, igual Process.Type) e Operação (COMPANY_OPERATIONS em models/Company.ts).
  companyType?: number | null;
  operation?: string | null;
  addresses: AddressFormData[];
  contacts: ContactFormData[];
}

export interface CvfRef {
  distributions?: number;
  logistics?: number;
  wtrading?: number;
  rondonia?: number;
}

export const processStatus = [
  { label: "ENTREPOSTO ADUANEIRO", value: "ENTREPOSTO ADUANEIRO" },
  { label: "DOCUMENTAÇÃO", value: "DOCUMENTAÇÃO" },
  { label: "AGUARDANDO RIC", value: "AGUARDANDO RIC" },
  { label: "MERCADORIA EM PRODUÇÃO", value: "MERCADORIA EM PRODUÇÃO" },
  { label: "LI", value: "LI" },
  { label: "DI", value: "DI" },
  { label: "EMBARQUE", value: "EMBARQUE" },
  { label: "EM TRÂNSITO", value: "EM TRÂNSITO" },
  { label: "DESEMBARAÇO", value: "DESEMBARAÇO" },
  { label: "DI CANAL AMARELO", value: "DI CANAL AMARELO" },
  { label: "DI CANAL VERMELHO", value: "DI CANAL VERMELHO" },
  { label: "BOOKING", value: "BOOKING" },
  { label: "CHEGOU NO PORTO DE DESTINO", value: "CHEGOU NO PORTO DE DESTINO" },
  {
    label: "AGUARDANDO PRESENÇA DE CARGA",
    value: "AGUARDANDO PRESENÇA DE CARGA",
  },
  {
    label: "CHEGOU NO AEROPORTO DE DESTINO",
    value: "CHEGOU NO AEROPORTO DE DESTINO",
  },
  { label: "MANIFESTADO", value: "MANIFESTADO" },
  { label: "ARMAZENADO", value: "ARMAZENADO" },
  { label: "DI REGISTRADA", value: "DI REGISTRADA" },
  { label: "DESEMBARAÇADO", value: "DESEMBARAÇADO" },
  { label: "EM CARREGAMENTO", value: "EM CARREGAMENTO" },
  { label: "ENTREGUE", value: "ENTREGUE" },
  { label: "CANCELADO", value: "CANCELADO" },
  { label: "AGUARDANDO FECHAMENTO", value: "AGUARDANDO FECHAMENTO" },
  { label: "ENCERRADO", value: "ENCERRADO" },
  {
    label: "AGUARDANDO LIBERAÇÃO SISCOMEX",
    value: "AGUARDANDO LIBERAÇÃO SISCOMEX",
  },
  {
    label: "AGUARDANDO LIBERAÇÃO PORTUÁRIA",
    value: "AGUARDANDO LIBERAÇÃO PORTUÁRIA",
  },
  { label: "AGUARDANDO NUMERÁRIO", value: "AGUARDANDO NUMERÁRIO" },
  { label: "AGUARDANDO LIBERAÇÃO MAPA", value: "AGUARDANDO LIBERAÇÃO MAPA" },
  { label: "AG. LIBERAÇÃO MAPA", value: "AG. LIBERAÇÃO MAPA" },
  { label: "AG. REMOÇÃO", value: "AG. REMOÇÃO" },
  {
    label: "AGUARDANDO APROVAÇÃO E DOCUMENTOS INICIAIS",
    value: "AGUARDANDO APROVAÇÃO E DOCUMENTOS INICIAIS",
  },
  {
    label: "AGUARDANDO LIBERAÇÃO SISCARGA",
    value: "AGUARDANDO LIBERAÇÃO SISCARGA",
  },
  { label: "PROFORMA MASTER", value: "PROFORMA MASTER" },
  { label: "AG. APROVAÇÃO FRETE", value: "AG. APROVAÇÃO FRETE" },
  { label: "AG. LIBERAÇÃO POLY", value: "AG. LIBERAÇÃO POLY" },
  { label: "AGUARDANDO FATURAMENTO", value: "AGUARDANDO FATURAMENTO" },
  { label: "AG. DESPESA DESPACHANTE", value: "AG. DESPESA DESPACHANTE" },
  { label: "AG. CORREÇÃO CE", value: "AG. CORREÇÃO CE" },
];
